import React from 'react';
import { trackingService } from 'services/tracking/TrackingService.js';
import ExpiredAccess from './ExpiredAccess.jsx';

const NoOrgAccess = ({ memberships }) => {

  trackingService.track({
    eventType: 'no-org-access:init',
    memberships: memberships?.map(({ org, user }) => `${org.title}: ${user.roles.join(',')}`),
  });

  return (
    <div style={styles.wrapper}>
      <ExpiredAccess />
    </div>
  );
};

const styles = {
  wrapper: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

export default NoOrgAccess;
